'use client'

import NewsletterForm from '@/components/forms/SignUpForm'
import { BasicModal } from '@/components/modals/BasicModal'
import { Button } from '@/components/ui/Button'
import { freePitch } from '@/constants/plans'
import { track } from '@/lib/tracking'
import { useState } from 'react'

export default function SubscribeModalTrigger({
  size = 'sm',
  // 'default' isn't a Button variant — it silently rendered unstyled (ghost).
  variant = 'outline',
  className = '',
  location = 'header',
  label = 'Subscribe',
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpen = () => {
    setIsModalOpen(true)
    track('subscribe_modal_opened', { location })
  }

  // Dismissal only — a successful signup closes via onSuccess without this event
  const handleClose = () => {
    setIsModalOpen(false)
    track('subscribe_modal_closed', { location })
  }

  return (
    <>
      <Button
        size={size}
        variant={variant}
        className={className}
        onClick={handleOpen}
      >
        {label}
      </Button>

      <BasicModal
        isOpen={isModalOpen}
        onClose={handleClose}
        className="max-w-md"
      >
        {/* Same promise, in the same words, as the subscribe card
            (SubscribeCard), so the modal reads as the next step rather
            than a different pitch. */}
        <div className="mb-6 text-center">
          <h2 className="mb-2 font-serif text-2xl font-medium text-foreground">
            Both sides, every morning
          </h2>
          <p className="font-sans text-[15px] leading-snug text-muted-foreground">
            {freePitch()}
          </p>
        </div>

        <NewsletterForm
          buttonLabel="Subscribe free"
          onSuccess={() => setIsModalOpen(false)}
          trackingLocation="header_modal"
        />

        <div className="mt-4 text-center text-xs text-muted-foreground">
          Free. No spam. Unsubscribe anytime.
        </div>
      </BasicModal>
    </>
  )
}
